import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Web3 from "web3";

// disconnect metamask wallet
export const disconnectWallet = () => {
  localStorage.removeItem("isWalletConnected");
  localStorage.removeItem("address");
  toast.info("Wallet disconnected");
};

// export const web3 = new Web3("https://rpc.ankr.com/eth");
export const web3 = new Web3("https://rpc.ankr.com/eth_goerli");

const NFTAddress = "0xb7f2bF7BB4B658546656b0F032fcAD05238A03e0";
const NFTABI = [
  {
    inputs: [{ internalType: "uint256", name: "_mintAmount", type: "uint256" }],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "price",
    outputs: [
      {
        internalType: "uint256",
        name: "weiAmount",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export const NFTContract = new web3.eth.Contract(NFTABI, NFTAddress);

export const isWalletConnected = () => {
  if (localStorage.getItem("isWalletConnected") === "true") {
    return true;
  }

  return false;
};

export const connectWalletLocaly = (address) => {
  localStorage.setItem("isWalletConnected", true);
  localStorage.setItem("address", address);
};
